import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginModule } from './features/login/login.module';

@NgModule({
    declarations: [AppComponent],
    imports: [BrowserAnimationsModule, CoreModule, AppRoutingModule, LoginModule],
    providers: [],
    bootstrap: [AppComponent],
})
export class AppModule {}
